// Maps file extensions to { label, bg (background), fg (foreground text) }
const EXT_MAP = {
  // JavaScript / TypeScript
  js:            { label: 'JS',    bg: '#f0db4f', fg: '#000' },
  mjs:           { label: 'MJS',   bg: '#f0db4f', fg: '#000' },
  cjs:           { label: 'CJS',   bg: '#f0db4f', fg: '#000' },
  ts:            { label: 'TS',    bg: '#3178c6', fg: '#fff' },
  jsx:           { label: 'JSX',   bg: '#61dafb', fg: '#000' },
  tsx:           { label: 'TSX',   bg: '#61dafb', fg: '#000' },

  // Web
  html:          { label: 'HTML',  bg: '#e44d26', fg: '#fff' },
  htm:           { label: 'HTM',   bg: '#e44d26', fg: '#fff' },
  css:           { label: 'CSS',   bg: '#264de4', fg: '#fff' },
  scss:          { label: 'SCSS',  bg: '#c6538c', fg: '#fff' },
  sass:          { label: 'SASS',  bg: '#c6538c', fg: '#fff' },
  less:          { label: 'LESS',  bg: '#1d365d', fg: '#fff' },

  // Data / Config
  json:          { label: 'JSON',  bg: '#fbc02d', fg: '#000' },
  xml:           { label: 'XML',   bg: '#f89820', fg: '#fff' },
  yaml:          { label: 'YAML',  bg: '#cc3e44', fg: '#fff' },
  yml:           { label: 'YML',   bg: '#cc3e44', fg: '#fff' },
  toml:          { label: 'TOML',  bg: '#9c4121', fg: '#fff' },
  ini:           { label: 'INI',   bg: '#6e6e6e', fg: '#fff' },
  env:           { label: 'ENV',   bg: '#555',    fg: '#fff' },

  // Backend languages
  py:            { label: 'PY',    bg: '#3572a5', fg: '#fff' },
  php:           { label: 'PHP',   bg: '#777bb4', fg: '#fff' },
  rb:            { label: 'RB',    bg: '#cc342d', fg: '#fff' },
  java:          { label: 'JAVA',  bg: '#b07219', fg: '#fff' },
  go:            { label: 'GO',    bg: '#00add8', fg: '#fff' },
  rs:            { label: 'RS',    bg: '#ce422b', fg: '#fff' },
  cs:            { label: 'C#',    bg: '#178600', fg: '#fff' },
  cpp:           { label: 'C++',   bg: '#f34b7d', fg: '#fff' },
  cc:            { label: 'C++',   bg: '#f34b7d', fg: '#fff' },
  c:             { label: 'C',     bg: '#555',    fg: '#fff' },
  h:             { label: '.H',    bg: '#555',    fg: '#fff' },
  hpp:           { label: 'HPP',   bg: '#f34b7d', fg: '#fff' },
  swift:         { label: 'SW',    bg: '#f05138', fg: '#fff' },
  kt:            { label: 'KT',    bg: '#7f52ff', fg: '#fff' },
  sh:            { label: 'SH',    bg: '#4eaa25', fg: '#fff' },
  bash:          { label: 'SH',    bg: '#4eaa25', fg: '#fff' },
  ps1:           { label: 'PS',    bg: '#012456', fg: '#fff' },
  lua:           { label: 'LUA',   bg: '#000080', fg: '#fff' },
  sql:           { label: 'SQL',   bg: '#e38c00', fg: '#fff' },
  r:             { label: 'R',     bg: '#276dc3', fg: '#fff' },
  dart:          { label: 'DART',  bg: '#00b4ab', fg: '#fff' },
  ex:            { label: 'EX',    bg: '#6e4a7e', fg: '#fff' },
  exs:           { label: 'EXS',   bg: '#6e4a7e', fg: '#fff' },

  // Images
  png:           { label: 'PNG',   bg: '#4caf50', fg: '#fff' },
  jpg:           { label: 'JPG',   bg: '#4caf50', fg: '#fff' },
  jpeg:          { label: 'JPG',   bg: '#4caf50', fg: '#fff' },
  gif:           { label: 'GIF',   bg: '#4caf50', fg: '#fff' },
  webp:          { label: 'WEBP',  bg: '#4caf50', fg: '#fff' },
  ico:           { label: 'ICO',   bg: '#4caf50', fg: '#fff' },
  bmp:           { label: 'BMP',   bg: '#4caf50', fg: '#fff' },
  svg:           { label: 'SVG',   bg: '#ff9800', fg: '#fff' },
  avif:          { label: 'AVIF',  bg: '#4caf50', fg: '#fff' },

  // Video
  mp4:           { label: 'MP4',   bg: '#f44336', fg: '#fff' },
  webm:          { label: 'WEBM',  bg: '#f44336', fg: '#fff' },
  mov:           { label: 'MOV',   bg: '#f44336', fg: '#fff' },
  avi:           { label: 'AVI',   bg: '#f44336', fg: '#fff' },
  mkv:           { label: 'MKV',   bg: '#f44336', fg: '#fff' },

  // Audio
  mp3:           { label: 'MP3',   bg: '#9c27b0', fg: '#fff' },
  wav:           { label: 'WAV',   bg: '#9c27b0', fg: '#fff' },
  ogg:           { label: 'OGG',   bg: '#9c27b0', fg: '#fff' },
  flac:          { label: 'FLAC',  bg: '#9c27b0', fg: '#fff' },
  aac:           { label: 'AAC',   bg: '#9c27b0', fg: '#fff' },

  // Documents
  md:            { label: 'MD',    bg: '#083fa1', fg: '#fff' },
  mdx:           { label: 'MDX',   bg: '#083fa1', fg: '#fff' },
  txt:           { label: 'TXT',   bg: '#757575', fg: '#fff' },
  pdf:           { label: 'PDF',   bg: '#f44336', fg: '#fff' },
  docx:          { label: 'DOC',   bg: '#2b579a', fg: '#fff' },
  doc:           { label: 'DOC',   bg: '#2b579a', fg: '#fff' },
  xlsx:          { label: 'XLS',   bg: '#217346', fg: '#fff' },
  xls:           { label: 'XLS',   bg: '#217346', fg: '#fff' },
  csv:           { label: 'CSV',   bg: '#217346', fg: '#fff' },

  // Archives
  zip:           { label: 'ZIP',   bg: '#ff9800', fg: '#fff' },
  tar:           { label: 'TAR',   bg: '#ff9800', fg: '#fff' },
  gz:            { label: 'GZ',    bg: '#ff9800', fg: '#fff' },
  rar:           { label: 'RAR',   bg: '#ff9800', fg: '#fff' },
  '7z':          { label: '7Z',    bg: '#ff9800', fg: '#fff' },

  // Git / VCS
  gitignore:     { label: 'GIT',   bg: '#f54d27', fg: '#fff' },
  gitattributes: { label: 'GIT',   bg: '#f54d27', fg: '#fff' },
  gitmodules:    { label: 'GIT',   bg: '#f54d27', fg: '#fff' },
};

/**
 * Returns an HTML badge span for the file extension, or null for unknown types.
 * @param {string} filename
 * @returns {string|null}
 */
export function resolveFileIcon(filename) {
  const dotIndex = filename.lastIndexOf('.');
  const ext = dotIndex !== -1 ? filename.slice(dotIndex + 1).toLowerCase() : '';

  // Support dotfiles like ".gitignore" → key is "gitignore"
  const key = ext || (filename.startsWith('.') ? filename.slice(1).toLowerCase() : '');
  const match = EXT_MAP[key];
  if (!match) return null;
  return `<span class="file-ext-badge" style="background:${match.bg};color:${match.fg}">${match.label}</span>`;
}
  